/**
 *  api + utils
 */
import {
  ZWSHelper
} from '@/native/ZWSHelper.js'
export const LoginLogic = {
  /**
   *  登录
   * @param {*} data 用户登录信息 {username: '',password: ''}
   * @param {*} callback 回调
   */
  login (username, password) {
    return new Promise((resolve, reject) => {
      ZWSHelper.login({
        username: username,
        password: password
      }).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./third_party/common_app/LoginModule/Logic/LoginLogic.js